export const findHighestLexileWithinRange = (
  sortedContentLevels,
  readingLevelLexileRange,
  language,
) => {
  const [minLevelValue, maxLevelValue] = readingLevelLexileRange;

  const sortedLevelsWithinRange = sortedContentLevels.filter((level) => {
    if (language && level.language !== language) {
      return false;
    }

    return (
      level.raw_lexile >= minLevelValue && level.raw_lexile <= maxLevelValue
    );
  });

  const highestLexileThatFitsRange =
    sortedLevelsWithinRange[sortedLevelsWithinRange.length - 1];

  return highestLexileThatFitsRange;
};
